import {
    useAddProductsToWishlist,
    AddWishlistVariableInterface
} from './use-add-products-to-wishlist'
import { useUI, ToastType } from '@corratech/pylot-ui/context'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { useStoreConfig } from '@config/hooks/useStoreConfig'

export interface UseWishlistActionInterface {
    handleAddWishlistAction: (
        itemsData: AddWishlistVariableInterface,
        isConfig: boolean,
        stayOnPage?: boolean
    ) => void
    isLoading: boolean
}

export const useWishlistActions = (): UseWishlistActionInterface => {
    const { t } = useTranslation(['wishlist'])
    const { openToast } = useUI()
    const { addProductsToWishlist, isLoading } = useAddProductsToWishlist()
    const router = useRouter()
    const config = useStoreConfig()

    const handleAddWishlistAction = async (
        itemsData: AddWishlistVariableInterface,
        isConfig: boolean,
        stayOnPage?: boolean
    ) => {
        if (isConfig && !itemsData?.itemOptions[0]?.selected_options?.length) {
            openToast(
                t('wishlist|Please select a variant with stock to proceed.'),
                ToastType.Danger
            )
            return false
        }

        const response = await addProductsToWishlist(itemsData)
        if (response?.errors?.length) {
            //handle errors
            openToast(
                t('wishlist|Something went wrong. Please try again'),
                ToastType.Danger
            )
        }

        if (response?.data?.addProductsToWishlist) {
            const {
                id: routeId
            } = response?.data?.addProductsToWishlist?.wishlist
            const redirectUrl = config.base.wishlist.multiple_wishlists
                ? `/account/wishlist/${routeId}`
                : '/account/wishlist'

            if (stayOnPage) {
                openToast(
                    t('wishlist|Product has been added to your Wish List.'),
                    ToastType.Success
                )
            } else {
                router.push(redirectUrl).then(() => {
                    openToast(
                        t('wishlist|Product has been added to your Wish List.'),
                        ToastType.Success
                    )
                })
            }
        }
    }

    return {
        handleAddWishlistAction,
        isLoading
    }
}
